// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35q9W","delete":"styles_delete__fucBZ","update":"styles_update__10RCP","add":"styles_add__25X_p"};